module.exports = __webpack_public_path__ + "img/rons_slug_bucket.895ffbba.jpg";